import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
// eslint-disable-next-line import/no-unassigned-import
import "@faire/retailer-visitor-shared/components/slick.css";
import { BrandsLandingPageTestimonialTile } from "@faire/retailer-visitor-shared/views/brands/landing-page/BrandsLandingPageTestimonialTile";
import { getCategoriesGroup, getIsShowingCaseStudies } from "@faire/retailer-visitor-shared/views/brands/landing-page/const";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackBrandLeadsBrandsPageCategoryTestimonialClick } from "@faire/web-api--source/events/brandLeads/click/brandsPageCategoryTestimonial";
import { trackBrandLeadsBrandPageCategoryTestimonialView } from "@faire/web-api--source/events/brandLeads/view/brandPageCategoryTestimonial";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
var BrandsLandingPageTestimonialsBase = function(param) {
    var initialSlide = param.initialSlide, isPersonalized = param.isPersonalized;
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(initialSlide !== null && initialSlide !== void 0 ? initialSlide : 0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    useEffect(function() {
        trackBrandLeadsBrandPageCategoryTestimonialView();
    }, []);
    var isSSR = useIsSSR();
    var currentSelectedCategory = getCategoriesGroup(isSSR, strictLocalize)[currentIndex];
    if (!currentSelectedCategory) {
        return null;
    }
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        children: /*#__PURE__*/ _jsx(Container, {
            $bgColor: isPersonalized ? currentSelectedCategory.backgroundColor : Core.surface.inverse,
            $opacity: currentSelectedCategory.opacity,
            $showCaseStudies: getIsShowingCaseStudies(),
            children: isTabletAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "5x"
                    }),
                    /*#__PURE__*/ _jsx(StaticCategories, {
                        currentIndex: currentIndex,
                        isPersonalized: isPersonalized,
                        setCurrentIndex: setCurrentIndex,
                        currentSelectedCategory: currentSelectedCategory
                    })
                ]
            }) : null
        })
    });
};
var StaticCategoriesBase = function(param) {
    var currentIndex = param.currentIndex, setCurrentIndex = param.setCurrentIndex, currentSelectedCategory = param.currentSelectedCategory, isPersonalized = param.isPersonalized;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isDesktopAndAbove = _useViewport.isDesktopAndAbove, isTablet = _useViewport.isTablet;
    var imageWidth = useResponsiveValue({
        mobileAndAbove: 312,
        tabletAndAbove: 720,
        desktopAndAbove: 820,
        xLargeAndAbove: 915
    });
    var handleClickRoundedTitle = function(index, eventKey) {
        setCurrentIndex(index);
        trackBrandLeadsBrandsPageCategoryTestimonialClick(eventKey);
    };
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: isDesktopAndAbove ? "displayLSerifRegular" : isTablet ? "displayMSerifRegular" : "displaySSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "gwthHX",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Grow, no matter what you sell"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(RoundedTitleWrapper, {
                children: getCategoriesGroup(isSSR, strictLocalize).map(function(item, index) {
                    return /*#__PURE__*/ _jsx("div", {
                        onClick: function() {
                            return handleClickRoundedTitle(index, item.eventKey);
                        },
                        children: /*#__PURE__*/ _jsx(RoundedTitle, {
                            $isSelected: index === currentIndex,
                            children: item.header
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(BrandsLandingPageTestimonialTile, {
                        category: currentSelectedCategory,
                        isMobile: isMobile,
                        isPersonalized: isPersonalized
                    }),
                    isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "3x"
                            }),
                            /*#__PURE__*/ _jsx(LogoImage, {
                                src: optimizeImageUrl({
                                    url: currentSelectedCategory.mobileLogoImageUrl
                                }, isSSR, {
                                    width: 312,
                                    height: 158
                                }),
                                width: 312,
                                height: 158
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "6x"
                            }),
                            /*#__PURE__*/ _jsx(LogoImage, {
                                src: optimizeImageUrl({
                                    url: currentSelectedCategory.logoImageUrl
                                }, isSSR, {
                                    height: 100,
                                    width: imageWidth
                                }),
                                height: 100,
                                width: imageWidth
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            })
        ]
    });
};
var StaticCategories = observer(StaticCategoriesBase);
export var BrandsLandingPageTestimonials = observer(BrandsLandingPageTestimonialsBase);
var Container = styled(Column).withConfig({
    componentId: "sc-50e96162-0"
})([
    "background-color:",
    "",
    ";width:100%;height:fit-content;",
    " ",
    "{border:0;background-color:",
    "",
    ";}transition:background-color 0.5s ease-in-out;"
], function(props) {
    return props.$showCaseStudies ? Decorative.tint.neutral : props.$bgColor;
}, function(props) {
    return props.$opacity;
}, function(props) {
    return props.$showCaseStudies ? null : css([
        "border:24px solid white;"
    ]);
}, responsiveMediaQueries.mobile, function(props) {
    return props.$bgColor;
}, function(props) {
    return props.$opacity;
});
var LogoImage = styled.img.withConfig({
    componentId: "sc-50e96162-1"
})([
    "object-position:center;"
]);
var RoundedTitleWrapper = styled(Row).withConfig({
    componentId: "sc-50e96162-2"
})([
    "overflow:auto;padding:0 8px;",
    "{width:100%;padding:0 24px;}"
], responsiveMediaQueries.tabletAndBelow);
var RoundedTitle = styled(Typography).withConfig({
    componentId: "sc-50e96162-3"
})([
    "&&&{padding:10px 18px;white-space:nowrap;background-color:",
    ";color:",
    ";transition:background-color 0.2s ease-in-out;border-radius:50px;&:hover{cursor:pointer;}margin-bottom:24px;",
    "{width:100%;margin-bottom:16px;padding:10px 12px;}}"
], function(props) {
    return props.$isSelected ? Core.surface.default : "";
}, function(props) {
    return props.$isSelected ? Core.text.inverse : "";
}, responsiveMediaQueries.mobile);
